import Vue from "vue";
import VueMeta from "vue-meta";
import App from "src/App.vue";
import router from "src/router";
import store from "src/store";
import VueAnalytics from "vue-analytics";
import { i18n } from "src/i18n";

// directive
import cursor from "./directives/cursor";
import view from "src/directives/view";
// // Uncomment to see all routes for prerender-spa plugin
// import renderRoutes from 'src/render-routes'
// renderRoutes()

// Var
Vue.config.productionTip = false;

// Meta descriptions
Vue.use(VueMeta, {});

// Analytics
const isProd = process.env.NODE_ENV === "production";
Vue.use(VueAnalytics, {
  id: "UA-150340840-1",
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});

// Initial load
store.dispatch("global/init").then(() => {
  // Vue instance
  new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
  }).$mount("#app");
});
